// 导出页面为PDF格式
import html2canvas from 'html2canvas'
// import JsPDF from 'jspdf'

// export function getPdf(title, id,height){
//     console.log(height)
//   html2Canvas(document.querySelector(`#${id}`), {
//     allowTaint: true
//   }).then(function (canvas) {
//     let contentWidth = canvas.width
//     let contentHeight = canvas.height
//     let pageHeight = (contentWidth / 592.28 )* 841.89
//     let leftHeight = contentHeight
//     let position = 0
//     let imgWidth = 595.28
//     let imgHeight = (592.28 / contentWidth) * contentHeight;
//     let pageData = canvas.toDataURL('image/jpeg', 1.0)
//     let PDF = new JsPDF('', 'pt', 'a4')
//     if (leftHeight < pageHeight) {
//       PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
//     } else {
//       while (leftHeight > 0) {
//         PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
//         leftHeight -= pageHeight
//         position -= 841.89
//         if (leftHeight > 0) {
//           PDF.addPage()
//         }
//       }
//     }
//     PDF.save(title + '.pdf')
//   }
//   )
// }
export function printHtml(html) {
    let style = getStyle();
    let container = getContainer(html);
    document.body.appendChild(style);
    document.body.appendChild(container);
    getLoadPromise(container).then(() => {
      window.print();
      document.body.removeChild(style);
      document.body.removeChild(container);
    });
  }
  // 设置打印样式
  function getStyle() {
  let styleContent = `#print-container {
      display: none;
  }
  @media print {
      body > :not(.print-container) {
          display: none;
      }
      html,
      body {
        margin: 0 0.2cm;
        display: block !important;
        height:auto;
      }
      #print-container {
          display: block;
      }
      @page {
        margin: 0.25cm 0;
      }
  }`;
    let style = document.createElement("style");
    style.innerHTML = styleContent;
    return style;
  }
  // 清空打印内容
  function cleanPrint() {
    let div = document.getElementById('print-container')
    if (!!div) {
      document.querySelector('body').removeChild(div)
    }
  }
  // 新建DOM，将需要打印的内容填充到DOM
  function getContainer(html) {
    cleanPrint()
    let container = document.createElement("div");
    container.setAttribute("id", "print-container");
    container.innerHTML = html;
    return container;
  }
  // 图片完全加载后再调用打印方法
  function getLoadPromise(dom) {
    let imgs = dom.querySelectorAll("img");
    imgs = [].slice.call(imgs);
   
    if (imgs.length === 0) {
      return Promise.resolve();
    }
    let finishedCount = 0;
    return new Promise(resolve => {
      function check() {
        finishedCount++;
        if (finishedCount === imgs.length) {
          resolve();
        }
      }
      imgs.forEach(img => {
        img.addEventListener("load", check);
        img.addEventListener("error", check);
      })
    });
  }
  export function printFn(printContent){
    
    // 获取dom 宽度 高度
    const width = printContent.clientWidth;
    const height = printContent.clientHeight;
    // 创建一个canvas节点
    const canvas = document.createElement('canvas');
  
    const scale = 4; // 定义任意放大倍数，支持小数；越大，图片清晰度越高，生成图片越慢。
    canvas.width = width * scale; // 定义canvas 宽度 * 缩放
    canvas.height = height * scale; // 定义canvas高度 *缩放
    canvas.style.width = width * scale + 'px';
    canvas.style.height = height * scale + 'px';
    canvas.getContext('2d').scale(scale, scale); // 获取context,设置scale
    console.log(document.documentElement.scrollTop,document.body.scrollTop)
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop; // 获取滚动轴滚动的长度
    const scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft; // 获取水平滚动轴的长度
  
    html2canvas(printContent, {
      canvas,
      backgroundColor: null,
      useCORS: true,
      windowHeight: document.body.scrollHeight,
      scrollX: -scrollLeft, // 解决水平偏移问题，防止打印的内容不全
      scrollY: -scrollTop
    }).then((canvas) => {
      const url = canvas.toDataURL('image/png')
      printJS({
      printable: url,
      type: 'image',
      documentTitle: '', // 标题
      style: '@page{size:auto;margin: 0cm 1cm 0cm 1cm;}' // 去除页眉页脚
      })
    }).catch(err=>{
      console.error(err);
    })
  }



// WEBPACK FOOTER //
// ./src/util/exportPdf.js